import { _ as _sfc_main } from "./VaFileUploadUndo.vue_vue_type_script_lang-40a99697.mjs";
import { resolveComponent, openBlock, createElementBlock, Fragment, createVNode, normalizeStyle, createElementVNode, normalizeClass, toDisplayString, withCtx, createTextVNode } from "vue";
import { _ as _export_sfc } from "../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaFileUploadUndo_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = { class: "va-file-upload-undo__text" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_progress_bar = resolveComponent("va-progress-bar");
  const _component_va_button = resolveComponent("va-button");
  return openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_va_progress_bar, {
      "model-value": _ctx.progress,
      rounded: false,
      class: "va-file-upload-undo-progress-bar",
      style: normalizeStyle(`--va-0-undo-duration-style: ${String(_ctx.undoDurationStyle)}`)
    }, null, 8, ["model-value", "style"]),
    createElementVNode("div", {
      class: normalizeClass(["va-file-upload-undo", _ctx.computedClasses]),
      style: normalizeStyle(`--va-0-undo-duration-style: ${String(_ctx.undoDurationStyle)}`)
    }, [
      createElementVNode("span", _hoisted_1, toDisplayString(_ctx.deletedFileMessage), 1),
      createVNode(_component_va_button, {
        class: "va-file-upload-undo__button",
        "aria-label": _ctx.undoButtonText,
        size: "small",
        outline: "",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("recover"))
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.undoButtonText), 1)
        ]),
        _: 1
      }, 8, ["aria-label"])
    ], 6)
  ], 64);
}
const _VaFileUploadUndo = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaFileUploadUndo as _
};

import '../../../../VaFileUploadUndo.css';
//# sourceMappingURL=VaFileUploadUndo-61e438f3.mjs.map
